import { Link } from "react-router-dom";
import "./index.css";
import { useContext, useEffect } from "react";
import { AppContext } from "../../context/AppContext";
import { Helmet } from "react-helmet-async";

const Services = () => {
  const { setActiveRoute, setActiveSection } = useContext(AppContext);

  useEffect(() => {
    setActiveRoute("/careers");
    setActiveSection("");
  }, [setActiveRoute, setActiveSection]);

  const services = [
    {
      id: 0,
      service: "Web Hosting",
      image:
        "https://iqteche.in/static/media/wl_client_images/c1126d746bdb4597ba5a27b2974eab49.jpeg",
    },

    {
      id: 1,
      service: "Web Development",
      image:
        "https://iqteche.in/static/media/wl_client_images/bfa8d35d1a474a89abb34b2a0d614b21.jpg",
    },

    {
      id: 2,
      service: "Web Design",
      image:
        "https://iqteche.in/static/media/wl_client_images/4ba1ec948ed04e9cb84b0ccbe033b565.jpg",
    },

    {
      id: 3,
      service: "Server",
      image:
        "https://iqteche.in/static/media/wl_client_images/3f670da31626492b92f81a95f390951a.png",
    },

    {
      id: 4,
      service: "Google ADS",
      image:
        "https://iqteche.in/static/media/wl_client_images/5b4ef4e8110443deb99f63280cf6180a.png",
    },
  ];

  useEffect(() => {
    setActiveRoute("/services");
  }, [setActiveRoute]);

  return (
    <>
      <Helmet>
        <title>
          Complete Web Services in Hyderabad | Hosting, Design & Google Ads
        </title>
        <link rel="canonical" href="https://ibixqt.in/services" />
        <meta
          name="description"
          content="Build your online presence with IBIX Qodify – offering web hosting, responsive web design, development, server setup, and Google Ads management for your business."
        />
      </Helmet>
      <section className="services-section d-flex flex-column justify-content-center align-items-center">
        {services.length > 0 ? (
          <div className="container">
            <div className="row">
              {services.map((item) => (
                <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                  <div className="service-card shadow text-center">
                    <img
                      src={item.image}
                      alt={item.service}
                      className="service-img w-100"
                    />
                    <button className="btn btn-dark w-100 mt-3">
                      {item.service}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div>
            <h1>Oops! Currently no services are available...</h1>
            <Link to={"/"}>
              <button className="btn btn-info">Return to Home</button>
            </Link>
          </div>
        )}
        <a
          href="https://forms.gle/kW3bVX7pcrUTj8hWA"
          target="_blank"
          rel="noreferrer"
        >
          <button className="get-quote-btn mb-5">Get Quote</button>
        </a>
      </section>
    </>
  );
};

export default Services;
